import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import bagIcon from "@/shared/assets/shopping-bag.svg";
import { useCart } from "../model/useCart";

/** «Корзинка» in the desktop header with the number of pieces. */
export function CartLink() {
  const { t } = useTranslation(["shop", "cart"]);
  const { count } = useCart();
  return (
    <Link
      to="/cart"
      className="relative flex items-center gap-2 p-2 hover:text-brand-600 lg:p-0"
      aria-label={count > 0 ? `${t("shop:cart")}: ${t("cart:count", { count })}` : t("shop:cart")}
    >
      <span className="relative">
        <img src={bagIcon} width={20} height={20} alt="" />
        {count > 0 && (
          <span
            aria-hidden
            className="absolute -top-2 -right-2 flex h-4 min-w-4 items-center justify-center rounded-full bg-danger px-1 text-[10px] leading-none font-semibold text-white"
          >
            {count > 99 ? "99+" : count}
          </span>
        )}
      </span>
      <span className="max-lg:sr-only" aria-hidden>
        {t("shop:cart")}
      </span>
    </Link>
  );
}
